var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62402 11.0527C7.80863 11.0528 8.90246 11.4417 9.78418 12.0986C10.9964 13.0016 11.8087 14.4109 11.9082 16.0127C11.9152 16.123 11.9189 16.2346 11.9189 16.3467V16.9746H1V16.3467C1 13.4231 3.37049 11.053 6.29492 11.0527H6.62402ZM14.0693 10.0352C16.7876 10.0352 18.999 12.2468 18.999 14.9639V16.0127H12.9688C12.9304 15.274 12.7656 14.5567 12.4775 13.876C12.1577 13.1199 11.6998 12.4409 11.1172 11.8584C10.9197 11.6609 10.7112 11.4775 10.4922 11.3096C11.3674 10.5183 12.5267 10.0352 13.7969 10.0352H14.0693ZM6.46094 3C8.27191 3.00028 9.74508 4.56194 9.74512 6.48145C9.74512 8.40099 8.2719 9.96261 6.46094 9.96289C4.64975 9.96289 3.17578 8.40116 3.17578 6.48145C3.17582 4.56177 4.64978 3 6.46094 3ZM13.9287 3.49902C15.4734 3.49902 16.7374 4.82184 16.751 6.45898C16.7574 7.24881 16.4746 7.99547 15.9551 8.56152C15.4261 9.13775 14.716 9.45847 13.9561 9.46484C13.9485 9.46488 13.9402 9.46484 13.9326 9.46484C13.1812 9.46473 12.4755 9.15639 11.9424 8.59473C11.4134 8.03718 11.1179 7.29489 11.1113 6.50488C11.1049 5.71507 11.3876 4.9684 11.9072 4.40234C12.4362 3.82605 13.1462 3.50536 13.9062 3.49902C13.9136 3.49899 13.9213 3.49902 13.9287 3.49902Z",
    fill: "url(#paint0_linear_6_14035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_14035",
    x1: 9.99951,
    y1: 16.9746,
    x2: 9.99951,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.396826a487da771a0b77700b395d94c3.svg";
export { ForwardRef as ReactComponent };